import { Space, Spin } from "antd";

import { FC } from "react";
import classNames from "classnames";
import styles from "./PageLoader.module.scss";

interface PageLoaderProps {
  withHeader?: boolean;
}

const PageLoader: FC<PageLoaderProps> = ({ withHeader = false }) => {
  return (
    <div
      className={classNames(styles.Wrapper, {
        [styles.WithHeader]: withHeader,
      })}
    >
      <Space size="middle">
        <Spin size="large" />
      </Space>
    </div>
  );
};

export default PageLoader;
